import React, { useState } from "react";
import MediumButton from "../../../component/button/MediumButton";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";
import { motion } from "framer-motion";
import VisaImg from "../../../assets/kangaroo/AustraliaBanner.jpg";
import { data } from "../data.js";
import DynamicInlineForm from "../../../component/DynamicInline/DynamicInlineForm";
import { Col, Row } from "reactstrap";
import Map from "../../../Homepage/Map.jsx";
import SmallPage from "../../../Homepage/SmallPage.jsx";
import { ChevronDown, Download, Link2, Loader, Pointer, Section, Slice } from "lucide-react";
import Destinationcountry from "../../../services/Destinationcountry.js";
import { useQuery } from "@tanstack/react-query";
import { useLocation, useParams } from "react-router-dom";
import MainForm from "../component/MainForm.jsx";
import { imageBaseApi } from "../../../services/imageBaseApi.js";
import { div } from "framer-motion/client";
import Professional from "../../../Homepage/Professional.jsx";
import Form from "../../../component/Form/Form.jsx";
import ServiceModule from "../../../services/ServiceModule.js";
import WidgetsService from "../../../services/WidgetsService.js";
const ServicePage = () => {
  const oshcData = data;
  const { section } = useParams();
  const [isHovered, setIsHovered] = React.useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => setModalOpen(!modalOpen);
  const [hoveredId, setHoveredId] = useState(null)
  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const fetchData = async (section) => {
    const response = await ServiceModule.getBySlug(section);
    return response;
  };

  const { pathname } = useLocation();
  const slug = pathname.split("/").filter(Boolean).pop();

  const enumMap = {
    "visa-migration": 5,
    "education": 8,
    "oshc-ovhc": 4,
    "tax-return": 6,
    "kevs-fees-charges": 7
  };

  const fetchWidgets = async (isOnshore = true) => {
    const response = await WidgetsService.getHomeWidgets(enumMap[slug], isOnshore);
    return response;
  };

  const {
    data: WidgetData,
    isPending: WidgetPending,
    error: WidgetError,
  } = useQuery({
    queryKey: ["WidgetData", slug],
    queryFn: () => fetchWidgets(true),
  });





  const {
    isPending,
    error,
    data: serviceData,
  } = useQuery({
    queryKey: ["serviceData", section],
    queryFn: ({ queryKey }) => {
      const [, section] = queryKey;
      return fetchData(section);
    },
  });

  if (isPending) return <Loader style={{ height: "100vh", color: "#fff" }} />
  if (error) return <div>Error: {error.message}</div>;
  console.log("serviceData:", serviceData);
  console.log("subDetails:", serviceData?.subDetails);
  console.log("subDetails length:", serviceData?.subDetails?.length);

  return (
    <>
      <div
        className="hero-banner"
        style={{
          "--banner-img": `url(${imageBaseApi + serviceData?.bannerMedia?.url || VisaImg
            })`,
          overflow: "hidden",
        }}
      >
        <SectionContainer>
          {/* <BreadCrumb
            items={[
              { title: "HOME", link: "/" },
              { title: "SERVICES", link: "/services" },
              { title: serviceData?.name },
            ]}
            country={true}
            instituition={true}
          /> */}
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "400px" }} // Set your desired height
          >
            <h1
              className="banner-text-country"
              style={{ color: serviceData?.bannerTextColorCode }}
            >
              {serviceData?.bannerText}
            </h1>
          </div>
        </SectionContainer>
      </div>
      {section === "tax-return" && (
        <SectionContainer>
          {/* <p
          className="country-paragraph-text"
          dangerouslySetInnerHTML={{ __html: serviceData?.mainDescription }}
        /> */}
          {/* <h1 className='font-level-8'style={{marginTop:"71px", marginBottom:"31px"}}>{serviceData?.subDetails[0].title}</h1>
          <p
    className="country-paragraph-text"
    dangerouslySetInnerHTML={{ __html: serviceData?.subDetails[0].description }}
  /> */}
          {serviceData?.subDetails?.map((subDetail, subDetailIndex) => (
            <div key={subDetail.id}>
              <h1
                className="font-level-11 mt-5 py-4"
                style={{
                  marginBottom:
                    section === "visa-migration" ? "1.5rem" : undefined,
                }}
              >
                {subDetail.title}
              </h1>
              <hr className="text-dark" />
              {subDetail?.description && (
                <p
                  className="country-paragraph-text pt-3"
                  dangerouslySetInnerHTML={{ __html: subDetail.description }}
                />
              )}

              {subDetail.subDetailsMenus?.map((menu, menuIndex, menuArr) => (
                <React.Fragment key={menu.id}>
                  <hr className="line-visa " />

                  <h1
                    className="font-level-7"
                    style={{
                      marginBottom:
                        section === "visa-migration" ? "1.5rem" : undefined,
                    }}
                  >
                    {menu.title}
                  </h1>
                  <div className="d-flex flex-column">
                    {/* Menu Description */}
                    {menu.description && (
                      <div
                        className="country-paragraph-text text-black mb-3"
                        dangerouslySetInnerHTML={{ __html: menu.description }}
                      />
                    )}

                    {/* Contents */}
                    {menu.contents?.map((content, contentIndex) => (
                      <div key={content.id} className="mb-4">
                        {/* Content Heading */}
                        {content.heading && (
                          <h1 className="dropdown-font">{content.heading}</h1>
                        )}

                        {/* Content SubHeading */}
                        {content.subHeading && (
                          <h2 className="dropdown-font-sub">
                            {content.subHeading}
                          </h2>
                        )}

                        {/* Content Description */}
                        {content.description && (
                          <div
                            className="text-black mb-3"
                            dangerouslySetInnerHTML={{
                              __html: content.description,
                            }}
                          />
                        )}

                        {/* Content Image */}
                        {content.media?.url && (
                          <div
                            style={{
                              height: "350px",
                              width: "100%",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={imageBaseApi + content.media.url}
                              alt={
                                content.media.fileName ||
                                content.heading ||
                                "Content image"
                              }
                              className="rounded-5 w-100"
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        )}

                        {/* Content PDF - Download Button */}
                        {content?.pdf?.url && (
                          <a
                            href={content.pdf.url}
                            download={content.pdf.fileName}
                            className="btn btn-outline-primary mb-3"
                          >
                            Download {content.pdf.fileName}
                          </a>
                        )}
                      </div>
                    ))}

                    {/* Menu-level Download Button */}
                    {menu.pdf?.url && (
                      <div className="d-flex gap-5 mb-5">
                        <motion.button
                          className="rounded-full navbar-btn-font px-3"
                          style={{
                            backgroundColor: "white",
                            width: "max-content",
                            height: "45px",
                            position: "relative",
                            overflow: "hidden",
                            cursor: "pointer",
                            borderRadius: "50px",
                            border: "2px solid #FF4D1D",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          whileHover="hover"
                          onClick={() =>
                            window.open(imageBaseApi + menu.pdf.url, "_blank")
                          }
                        >
                          <motion.div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background:
                                "linear-gradient(to right, #83168F, #D40B84)",
                              zIndex: 0,
                            }}
                            initial={{ x: "-100%" }}
                            variants={{ hover: { x: 0 } }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                          />

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <motion.div
                              initial={{ color: "#7e1790" }}
                              variants={{
                                hover: {
                                  color: "#fff",
                                  transition: { duration: 0.5 },
                                },
                              }}
                              style={{
                                display: "inline-flex",
                                marginRight: "1rem",
                              }}
                            >
                              <Download />
                            </motion.div>

                            <motion.span
                              style={{ color: "#7e1790" }}
                              initial={{ color: "#7e1790" }}
                              className="fw-bold"
                              variants={{
                                hover: {
                                  color: "#fff",
                                  transition: { duration: 0.5 },
                                },
                              }}
                            >
                              DOWNLOAD PDF
                            </motion.span>
                          </div>
                        </motion.button>
                      </div>
                    )}
                  </div>

                  {menuIndex === menuArr.length - 1 && (
                    <hr className="line-visa" style={{ margin: 0 }} />
                  )}
                </React.Fragment>
              ))}
            </div>
          ))}
        </SectionContainer>
      )}

      {section === "kevs-fees-charges" && (
        <SectionContainer>
          {serviceData?.subDetails?.map((subDetail, subDetailIndex) => (
            <div key={subDetail.id}>
              <h1
                className="font-level-11 mt-5 pt-5"
                style={{
                  marginBottom:
                    section === "visa-migration" ? "1.5rem" : undefined,
                }}
              >
                {subDetail.title}
              </h1>

              {subDetail?.description && (
                <p
                  className="country-paragraph-text pt-3"
                  dangerouslySetInnerHTML={{ __html: subDetail.description }}
                />
              )}

              {subDetail.subDetailsMenus?.map((menu, menuIndex, menuArr) => (
                <React.Fragment key={menu.id}>
                  <hr className="line-visa " />

                  <h1
                    className="font-level-7"
                    style={{
                      marginBottom:
                        section === "visa-migration" ? "1.5rem" : undefined,
                    }}
                  >
                    {menu.title}
                  </h1>
                  <div className="d-flex flex-column">
                    {/* Menu Description */}
                    {menu.description && (
                      <div
                        className="text-black mb-3"
                        dangerouslySetInnerHTML={{ __html: menu.description }}
                      />
                    )}

                    {/* Contents */}
                    {menu.contents?.map((content, contentIndex) => (
                      <div key={content.id} className="mb-4">
                        {/* Content Heading */}
                        {content.heading && (
                          <h1 className="dropdown-font">{content.heading}</h1>
                        )}

                        {/* Content SubHeading */}
                        {content.subHeading && (
                          <h2 className="dropdown-font-sub">
                            {content.subHeading}
                          </h2>
                        )}

                        {/* Content Description */}
                        {content.description && (
                          <div
                            className="text-black mb-3"
                            dangerouslySetInnerHTML={{
                              __html: content.description,
                            }}
                          />
                        )}

                        {/* Content Image */}
                        {content.media?.url && (
                          <div
                            style={{
                              height: "350px",
                              width: "100%",
                              overflow: "hidden",
                            }}
                          >
                            <img
                              src={imageBaseApi + content.media.url}
                              alt={
                                content.media.fileName ||
                                content.heading ||
                                "Content image"
                              }
                              className="rounded-5 w-100"
                              style={{
                                height: "100%",
                                width: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </div>
                        )}

                        {/* Content PDF - Download Button */}
                        {content?.pdf?.url && (
                          <a
                            href={content.pdf.url}
                            download={content.pdf.fileName}
                            className="btn btn-outline-primary mb-3"
                          >
                            Download {content.pdf.fileName}
                          </a>
                        )}
                      </div>
                    ))}

                    {/* Menu-level Download Button */}
                    {menu.pdf?.url && (
                      <div className="d-flex gap-5 mb-5">
                        <motion.button
                          className="rounded-full navbar-btn-font px-3"
                          style={{
                            backgroundColor: "white",
                            width: "max-content",
                            height: "45px",
                            position: "relative",
                            overflow: "hidden",
                            cursor: "pointer",
                            borderRadius: "50px",
                            border: "2px solid #FF4D1D",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          whileHover="hover"
                          onClick={() =>
                            window.open(imageBaseApi + menu.pdf.url, "_blank")
                          }
                        >
                          <motion.div
                            style={{
                              position: "absolute",
                              top: 0,
                              left: 0,
                              right: 0,
                              bottom: 0,
                              background:
                                "linear-gradient(to right, #83168F, #D40B84)",
                              zIndex: 0,
                            }}
                            initial={{ x: "-100%" }}
                            variants={{ hover: { x: 0 } }}
                            transition={{ duration: 0.5, ease: "easeInOut" }}
                          />

                          <div
                            style={{
                              position: "relative",
                              zIndex: 1,
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <motion.div
                              initial={{ color: "#7e1790" }}
                              variants={{
                                hover: {
                                  color: "#fff",
                                  transition: { duration: 0.5 },
                                },
                              }}
                              style={{
                                display: "inline-flex",
                                marginRight: "1rem",
                              }}
                            >
                              <Download />
                            </motion.div>

                            <motion.span
                              style={{ color: "#7e1790" }}
                              initial={{ color: "#7e1790" }}
                              className="fw-bold"
                              variants={{
                                hover: {
                                  color: "#fff",
                                  transition: { duration: 0.5 },
                                },
                              }}
                            >
                              DOWNLOAD PDF
                            </motion.span>
                          </div>
                        </motion.button>
                      </div>
                    )}
                  </div>

                  {menuIndex === menuArr.length - 1 && (
                    <hr className="line-visa" style={{ margin: 0 }} />
                  )}
                </React.Fragment>
              ))}
            </div>
          ))}
        </SectionContainer>
      )}
      <SectionContainer>
        {section === "visa-migration" &&
          serviceData?.subDetails?.map((subDetail, subDetailIndex) => (
            <div key={subDetail.id} className="mb-12">
              <div
                className="d-flex align-items-center justify-content-between gap-2"
                style={{
                  cursor: "pointer",
                  marginTop: "80px",
                  marginBottom: "10px",
                }}
                onClick={() => handleToggle(`subDetail-${subDetailIndex}`)}
              >
                <h1 className="font-level-8" style={{ margin: 0 }}>
                  {subDetail.title}
                </h1>

                <div
                  style={{
                    display: "inline-block",
                    transition: "transform 0.3s ease, color 0.3s ease",
                    transform:
                      openIndex === `subDetail-${subDetailIndex}`
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    color: "#727272",
                  }}
                >
                  <ChevronDown size="2rem" />
                </div>
              </div>

              <hr
                style={{
                  height: "2px",
                  backgroundColor: "#000000",
                  border: "none",
                }}
              />

              {/* Only render the description if this item is open */}
              {openIndex === `subDetail-${subDetailIndex}` &&
                subDetail?.description && (
                  <div
                    className="country-paragraph-text"
                    dangerouslySetInnerHTML={{ __html: subDetail.description }}
                    style={{ marginTop: "10px" }}
                  />
                )}
            </div>
          ))}
        {section !== "education" && (<div className="mb-5">
          {/* {WidgetData?.map((widget) => renderWidgetContent(widget?.widget?.description))} */}
          {/* {WidgetData?.filter((item) => item?.isOnshore === false)?.map(
            (item) => (
              <React.Fragment key={item.id}>
                {renderWidgetContent(item?.widget?.description)}
              </React.Fragment>
            ),
          )} */}

          {WidgetData?.map((widget) => {
            const children = widget?.widget?.children || [];

            return (
              <Row key={widget.id} style={{ flexWrap: "nowrap" }}>
                <Col>
                  {children
                    ?.sort((a, b) => a.orderIndex - b.orderIndex)
                    ?.map((item, i) => {
                      const hasUrl = (item?.url && item?.url !== "") || (item?.media?.url !== "" && item?.media?.url);

                      const heading = (
                        <h1
                          className="list-text lh-1"
                          style={{
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            whiteSpace: "normal",
                          }}
                        >
                          {item?.headingName}
                          {hoveredId === item.id && hasUrl && <Link2 size={16} className="ms-1" />}
                        </h1>
                      );

                      return (
                        <React.Fragment key={item.id}>
                          <hr
                            className="line"
                            style={{
                              marginTop: "3.4rem",
                              marginBottom: "2.5rem",
                            }}
                          />

                          {hasUrl ? (
                            <a
                              href={
                                item?.isPdf
                                  ? imageBaseApi + item?.media?.url
                                  : item?.url.startsWith("http")
                                    ? item?.url
                                    : `https://${item?.url}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cursor-pointer text-decoration-none"
                              onMouseEnter={() => setHoveredId(item.id)}
                              onMouseLeave={() => setHoveredId(null)}
                            >
                              {heading}
                            </a>
                          ) : (
                            heading
                          )}

                          <p
                            className="country-paragraph-text"
                            style={
                              i === children.length - 1
                                ? { marginBottom: "12.4rem" }
                                : { marginBottom: "0rem" }
                            }
                            dangerouslySetInnerHTML={{ __html: item?.description }}
                            ref={(el) => {
                              if (!el) return;

                              el.querySelectorAll("a").forEach((a) => {
                                a.style.textDecoration = "none";
                                a.style.color = "#7e1790";
                                a.target = "_blank";
                                a.rel = "noopener noreferrer";
                                a.style.position = "relative";

                                let icon;

                                const mouseEnter = () => {
                                  icon = document.createElement("span");
                                  icon.innerHTML = " 🔗";
                                  icon.style.marginLeft = "6px";
                                  icon.className = "hover-link-icon";

                                  a.appendChild(icon);
                                };

                                const mouseLeave = () => {
                                  if (icon && a.contains(icon)) {
                                    a.removeChild(icon);
                                  }
                                };

                                a.addEventListener("mouseenter", mouseEnter);
                                a.addEventListener("mouseleave", mouseLeave);
                              });

                              el.querySelectorAll("p").forEach((p) => {
                                p.style.margin = "0.4rem";
                              });
                            }}
                          />
                        </React.Fragment>
                      );
                    })}
                </Col>
              </Row>
            );
          })}
        </div>)}
      </SectionContainer>

      <div className="mt-5">{/* <MainForm params={section} /> */}</div>
      {section === "education" && (
        <SectionContainer>
          <div
            style={{ marginTop: "10rem", marginBottom: "10rem" }}
            className="p-0 mx-0"
          >
            <Professional />
          </div>
        </SectionContainer>
      )}
      {section === "education" && (<SectionContainer>
        <div className="mb-5">
          {/* {WidgetData?.map((widget) => renderWidgetContent(widget?.widget?.description))} */}
          {/* {WidgetData?.filter((item) => item?.isOnshore === false)?.map(
            (item) => (
              <React.Fragment key={item.id}>
                {renderWidgetContent(item?.widget?.description)}
              </React.Fragment>
            ),
          )} */}

          {WidgetData?.map((widget) => {
            const children = widget?.widget?.children || [];

            return (
              <Row key={widget.id} style={{ flexWrap: "nowrap" }}>
                <Col>
                  {children
                    ?.sort((a, b) => a.orderIndex - b.orderIndex)
                    ?.map((item, i) => {
                      const hasUrl = (item?.url && item?.url !== "") || (item?.media?.url !== "" && item?.media?.url);

                      const heading = (
                        <h1
                          className="list-text lh-1"
                          style={{
                            wordBreak: "break-word",
                            overflowWrap: "anywhere",
                            whiteSpace: "normal",
                          }}
                        >
                          {item?.headingName}
                          {hoveredId === item.id && hasUrl && <Link2 size={16} className="ms-1" />}
                        </h1>
                      );

                      return (
                        <React.Fragment key={item.id}>
                          <hr
                            className="line"
                            style={{
                              marginTop: "3.4rem",
                              marginBottom: "2.5rem",
                            }}
                          />

                          {hasUrl ? (
                            <a
                              href={
                                item?.isPdf
                                  ? imageBaseApi + item?.media?.url
                                  : item?.url.startsWith("http")
                                    ? item?.url
                                    : `https://${item?.url}`
                              }
                              target="_blank"
                              rel="noopener noreferrer"
                              className="cursor-pointer text-decoration-none"
                              onMouseEnter={() => setHoveredId(item.id)}
                              onMouseLeave={() => setHoveredId(null)}
                            >
                              {heading}
                            </a>
                          ) : (
                            heading
                          )}

                          <p
                            className="country-paragraph-text"
                            style={
                              i === children.length - 1
                                ? { marginBottom: "12.4rem" }
                                : { marginBottom: "0rem" }
                            }
                            dangerouslySetInnerHTML={{ __html: item?.description }}
                            ref={(el) => {
                              if (!el) return;

                              el.querySelectorAll("a").forEach((a) => {
                                a.style.textDecoration = "none";
                                a.style.color = "#7e1790";
                                a.target = "_blank";
                                a.rel = "noopener noreferrer";
                                a.style.position = "relative";

                                let icon;

                                const mouseEnter = () => {
                                  icon = document.createElement("span");
                                  icon.innerHTML = " 🔗";
                                  icon.style.marginLeft = "6px";
                                  icon.className = "hover-link-icon";

                                  a.appendChild(icon);
                                };

                                const mouseLeave = () => {
                                  if (icon && a.contains(icon)) {
                                    a.removeChild(icon);
                                  }
                                };

                                a.addEventListener("mouseenter", mouseEnter);
                                a.addEventListener("mouseleave", mouseLeave);
                              });

                              el.querySelectorAll("p").forEach((p) => {
                                p.style.margin = "0.4rem";
                              });
                            }}
                          />
                        </React.Fragment>
                      );
                    })}
                </Col>
              </Row>
            );
          })}
        </div>

      </SectionContainer>)}



      {/* <SectionContainer>
        <Form
          modal={modalOpen}
          toggle={toggleModal}
          heading=" Get the Guidance you Need"
          description=" Share a few details and we'll help you move forward with your study plans for this destination."
          additionalField={false}
          aus={true}
          isAppointment={true}
          closingMessage="YOU'RE ONE STEP CLOSER TO STARTING SMART"
          closingDesc="Our counselor will connect with you shortly"
        />
      </SectionContainer> */}

      {/* <hr className="line" />
      <SectionContainer>
        <Map />
        <hr className="line-style-testprep" />
        <SmallPage countryPage={true} />
      </SectionContainer> */}
    </>
  );
};

export default ServicePage;
